import styled from '@cthings.co/styled-components';

export const TableBlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
